import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import * as _ from "../../../../util/lodash";
import { Quill } from 'react-quill';
import validators from "../../../../validators";
import { colorProps } from "./custom-color-picker";
var EMPTY_VALUE = '<p><br></p>';
/**
 * Undo and redo functions for Custom Toolbar
 */

function _undoChange() {
  this.quill.history.undo();
}
/**
 * Redo changes function
 */


function _redoChange() {
  this.quill.history.redo();
}
/**
 * Handler for working with links. This override is needed, cause the 'default' link editor is NOT validating the links and just accept anything.
 */


function _linkHandler() {
  var range = this.quill.getSelection();
  if (range === null || range.length === 0) return; //no selection, just don't do anything

  var tooltip = this.quill.theme.tooltip;
  var textbox = tooltip.textbox; //adds/removes the error class to the input, depending of the url validity
  //returns url validity

  var validateUrl = function validateUrl(value) {
    var urlIsValid = validators.isPRURL()(value) === true;

    if (urlIsValid) {
      textbox.classList.remove('ql-error');
    } else {
      textbox.classList.add('ql-error');
    }

    return urlIsValid;
  };

  var textChangeHandler = function textChangeHandler(e) {
    validateUrl(e.target.value);
  };

  textbox.addEventListener('input', textChangeHandler); //we have to extend the original save/hide functionality in order to hook our validation related functionality into the quill url editor

  var originalTooltipSave = tooltip.save;
  var originalTooltipHide = tooltip.hide; //extends the save functionality to validate the url while trying to 'save' the url

  tooltip.save = function () {
    if (this.root.getAttribute('data-mode') === 'link') {
      //only override stuff when editing links
      var _link = _trimInstanceProperty(_).call(_, textbox.value);

      if (validateUrl(_link)) {
        originalTooltipSave.call(this);
      }
    } else {
      originalTooltipSave.call(this);
    }
  }; //clean up custom validation related handlers/functions and restore the originals


  tooltip.hide = function () {
    textbox.removeEventListener('input', textChangeHandler); //cleanup the input change handler

    tooltip.hide = originalTooltipHide; //restore to original hide function

    tooltip.save = originalTooltipSave; //restore to original save function

    tooltip.hide.call(this); //call the original hide function
  };

  var link = this.quill.getFormat().link || '';
  tooltip.edit('link', link); //showing up existing link in the editor

  validateUrl(link); //just in case they copy pasted a bad url, do validation
}
/**
 * Handler to clear formatting of the selected text. The default quill clean would remove ALL tags and ALL formatting.
 * We need to preserve links and also mentions.
 */


function _cleanHandler() {
  var range = this.quill.getSelection(); //if no selection, just don't clear anything

  if (range) {
    var _context, _context2;

    var contentBeforeSelection = this.quill.getContents(0, range.index); //going to preserve the text before the selection unchanged

    var selectionContent = this.quill.getContents(range.index, range.length); //selected text will be cleaned

    var contentAfterSelection = this.quill.getContents(range.index + range.length); //going to preserve the text after the selection unchanged
    //selected text is going throug a cleanup

    _forEachInstanceProperty(_context = selectionContent.ops).call(_context, function (op) {
      //skip the op if the insert is empty or when the insert contains the mention
      if (!op.insert || !op.insert.mention) {
        var link = op.attributes && op.attributes.link;

        if (!!link) {
          op.attributes = {
            link: link
          };
        } else {
          delete op.attributes;
        }
      }
    }); //last item is a \n. If we are selecting the text up to the next item, best to clear the formats on that too.


    if (contentAfterSelection.ops.length && range.index + range.length + 1 === this.quill.getLength()) {
      delete contentAfterSelection.ops[contentAfterSelection.ops.length - 1].attributes;
    }

    this.quill.setContents({
      ops: _concatInstanceProperty(_context2 = []).call(_context2, contentBeforeSelection.ops, selectionContent.ops, contentAfterSelection.ops)
    }, Quill.sources.USER);
  }
}
/**
 * Overriding the Quill getBounds function to fix an issue where the bounds are returned considering the editors full height. Because of this, the toolbar can show way bellow the editor.
 * Only changes are this two lines:
 * - bottom: Math.max(0, Math.min(bounds.bottom - containerBounds.top, containerBounds.height))
 * - top:    Math.max(0, Math.min(bounds.top - containerBounds.top, containerBounds.height))
 */


function getBounds(index, length) {
  if (length === void 0) {
    length = 0;
  }

  var bounds = null;

  if (typeof index === 'number') {
    bounds = this.selection.getBounds(index, length);
  } else {
    bounds = this.selection.getBounds(index.index, index.length);
  }

  if (!bounds) return null;
  var containerBounds = this.container.getBoundingClientRect();
  return {
    bottom: Math.max(0, Math.min(bounds.bottom - containerBounds.top, containerBounds.height)),
    //added code to contain the bounds within the box
    height: bounds.height,
    left: bounds.left - containerBounds.left,
    right: bounds.right - containerBounds.left,
    top: Math.max(0, Math.min(bounds.top - containerBounds.top, containerBounds.height)),
    //added code to contain the bounds within the box
    width: bounds.width
  };
}
/**
 * Generates a unique id to be used to link the quill toolbar and quill editor
 */


var createQuillId = function createQuillId() {
  return _.uniqueId('ck-quill-');
};
/**
 * Turns the array of supported richTextToolbar formats into an object we can easily check in the toolbar code for the formats we need to show.
 */


var toolbarOptionsArrToObj = _.memoize(function (optionsArr) {
  return _.keyBy(optionsArr);
}); //turning the array into an object for easier checks

/*
 * Quill modules to attach to editor
 * See https://quilljs.com/docs/modules/ for complete options
 */


var getQuillModules = _.memoize(function (toolbarId, quillModuleDataRef) {
  return {
    toolbar: {
      container: "#" + toolbarId,
      //this one is needed so we can link the toolbar with the quill editor
      handlers: {
        undo: _undoChange,
        redo: _redoChange,
        color: _.noop,
        //this fn is being called as soon as the color button is clicked. We want to handle it separately, so overwriting with _.noop here
        background: _.noop,
        //as above
        link: _linkHandler,
        clean: _cleanHandler
      }
    },
    mention: {
      mentionDenotationChars: ['@'],
      source: function source(searchTerm, renderList) {
        // This weird way of passing the mentions is necessary, because:
        // 1. the mention plugin is stupid.
        // 2. really, NO other reasons, just 1.
        // Changing this(mention) source function -> immediate quill crash
        // Getting another instance of this config -> as above...crash
        var mentionList = quillModuleDataRef.current.mentionList;
        var filteredMentions = searchTerm.length === 0 ? mentionList : _filterInstanceProperty(_).call(_, mentionList, function (mention) {
          var _context3;

          return _indexOfInstanceProperty(_context3 = mention.fullText.toLowerCase()).call(_context3, searchTerm.toLowerCase()) > -1;
        });
        renderList(filteredMentions, searchTerm);
      },
      dataAttributes: ['id', 'name', 'fullText'],
      renderItem: function renderItem(item, searchTerm) {
        return item.fullText;
      }
    },
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          handler: function handler(range, context) {
            return quillModuleDataRef.current.isMultiline; //will only allow using the Enter key when editing multiline text
          }
        },
        tab: {
          key: 9,
          handler: function handler(range, context) {
            return true; //turns off the TAB key, so it's no longer added to the text, but will move to the next field
          }
        },
        indent: {
          key: 'tab',
          format: ['list'],
          handler: function handler(range, context) {
            //will be turning off 'multilevel' indentation, only allowing ONE level of indentation
            if (context.format.list === 'ordered' || context.format.list === 'bullet') {
              return false;
            } else {
              if (context.collapsed && context.offset !== 0) return true;
              this.quill.format('indent', '+1', Quill.sources.USER);
            }
          }
        }
      }
    },
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false
    },
    history: {
      delay: 500,
      maxStack: 100,
      userOnly: true
    }
  };
}, function (toolbarId) {
  return "cache-" + toolbarId + "}";
});
/**
 * Can cut out the new lines and <br> <br /> tags from the given content
 * @param {string} content - html content
 * @param {boolean} isMultiline - when NOT multiline, it will cut out unwanted new line characters and <br> tags
 * @returns - clean html string
 */


var cleanContent = function cleanContent(content, isMultiline) {
  if (isMultiline === void 0) {
    isMultiline = false;
  }

  var value = isMultiline ? content : content.replace(/[\r\n]+|<br\s*[\/]?>/gi, ''); //cut out new line characters and <br> <br /> in one go.

  return value === EMPTY_VALUE ? '' : value;
};
/**
 * Tells if color/background are currently open(visible)
 */


var colorPickerIsVisible = function colorPickerIsVisible(visibility) {
  return visibility[colorProps.COLOR] || visibility[colorProps.BACKGROUND];
};

export default {
  getBounds: getBounds,
  createQuillId: createQuillId,
  toolbarOptionsArrToObj: toolbarOptionsArrToObj,
  getQuillModules: getQuillModules,
  cleanContent: cleanContent,
  colorPickerIsVisible: colorPickerIsVisible
};
//# sourceMappingURL=utils.js.map